var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        size: "mini",
        "popper-append-to-body": true,
        placeholder: _vm.placeholder,
        "popper-class": "multi-option",
      },
      on: { change: _vm.change, focus: _vm.focus, blur: _vm.blur },
      model: {
        value: _vm.singleDefault,
        callback: function ($$v) {
          _vm.singleDefault = $$v
        },
        expression: "singleDefault",
      },
    },
    _vm._l(_vm.options, function (item) {
      return _c("el-option", {
        key: item.id,
        attrs: { label: item.label, value: item.value },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }